module.exports = function getResource(label, vars = []) {
    let resources = {
        byClicking: 'By clicking “Join Now” you acknowledge that you are a U.S. or Canada ' +
            'resident and agree to Sephora’s',
        privacyPolicy: 'Privacy Policy',
        termsOfUse: 'Terms of Use',
        and: ', and ',
        biTerms: 'Beauty Insider Terms',
        receiveOffers: ', and to automatically receive Beauty Insider offers and ' +
            'notifications via email.',
        sephoraReCaptchaText: 'Sephora uses Google ReCaptcha and users are subject to Google’s',
        sephoraReCaptchaTextRegister: 'Sephora uses Google ReCaptcha and by registering, users are subject to Google’s',
        googlePrivacyPolicyLink: 'privacy policy',
        googleTermsLink: 'terms'
    };
    return resources[label];
};
